
export default function Input({...restProps}){
    return <input {...restProps} />;
}